$(document).ready(function() {

    if($('#search-and-filter').length){
        $('.loading').removeClass('show');
    
        $(document).on("change", "#search-and-filter #sort", function() {
            searchResource();
        });
    
        $(document).on("change", "#search-and-filter #filter", function() {
            searchResource();
        });
    
        $(document).on("change", "#search-and-filter #sector", function() {
            searchResource();
        });

        $("#search-and-filter .search-button").click(function(){
            searchResource();
        });

        document.getElementById("searchInput")
            .addEventListener("keyup", function(event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                searchResource();
            }
        });

        function searchResource(){
            $('.loading').addClass('show');

            var sector = $('#search-and-filter').find('#sector').val();
            if(!sector){
                sector = $('#search-and-filter').find('#sector option:selected').val();
            }
            
            var action = $('#search-and-filter').attr('action');
            if(sector){
                action = action + '/' + sector;
            }
            action = action + '#list';
            $('#search-and-filter').attr('action', action);
            $('#search-and-filter').submit();
        }
    }
});
